import * as H from 'history'
import  React from 'react'
import { MilestoneReportModel } from '../../models/MilestoneReportModel'
import { PrintBackButtons } from '../applicationForm-1/controls/PrintBackButtons'

export interface MilestoneSubmissionPageProps {
    history: H.History
    autoMilestoneReportIdentifier: string
    onPrint?: { (e: React.MouseEvent): any }
}

export class MilestoneSubmissionPage extends React.Component<MilestoneSubmissionPageProps, null> {
    constructor(props: MilestoneSubmissionPageProps) {
        super(props)
    }

    close = () => {
        this.props.history.push('/')
    }


    print = (e: React.MouseEvent) => {
        if (this.props.onPrint) this.props.onPrint(e)
        else window.print()
    }

    render() {
        const { autoMilestoneReportIdentifier } = this.props
        return (
            <div>
                <h2 className="mt-3">Milestone Report Confirmation</h2>
                <p>Your  Milestone Report ID is: {autoMilestoneReportIdentifier}</p>
                <p>Your milestone report has been submitted.</p>
                <p>
                    You can view your submitted milestone report in the Online Portal and you can also download your milestone report as a PDF.  If you need to make any changes to your submitted milestone report, please contact us on 13 28 78.
                </p>

                <p>
                    We will assess your milestone report and may contact you should we require any further information.
                    We will advise you of the outcome of your milestone report in writing.
                </p>

                 <PrintBackButtons onBack={this.close} onPrint={this.print} backLabel="Close" printLabel={this.props.onPrint ? 'Print to pdf' : 'Print'} /> 
            </div>
        )
    }
}
